import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { CadastrarCandidato } from '@app/models/sisrh.model';
import { AutenticacaoService } from '@app/services/autenticacao.service';
import { SisrhService } from '@app/services/sisrh.service';
import { AppUtil } from '@app/utils/app.util';
import { CamposValidator } from '@app/validators/campos.validator';
import { CpfValidator } from '@app/validators/cpf.validator';

import estadoCivil from '@assets/json/estado-civil.json';
import genero from '@assets/json/genero.json';
import layout from '@assets/json/layout.json';
import uf from '@assets/json/uf.json';
import { ModalService } from '@app/shared/services/modal.service';

@Component({
  templateUrl: './cadastro-usuario.page.html'
})
export class CadastroUsuarioPage implements OnInit, AfterViewInit {

  fgCadastroUsuario: FormGroup;
  enviando = false;
  mascaraCpf = AppUtil.mascararCpf();
  mascaraCep = AppUtil.mascararCep();
  mascaraTelefone = AppUtil.mascararTelefone();

  idGeneroMasculino = genero.idGeneroMasculino;
  idGeneroFeminino = genero.idGeneroFeminino;
  listaUf = uf;
  listaEstadoCivil = estadoCivil;

  layout = layout.cadastroUsuarioPage;

  constructor(
    private autenticacaoService: AutenticacaoService,
    private fb: FormBuilder,
    private modalService: ModalService,
    private router: Router,
    private sisrhService: SisrhService
  ) {

    if (this.autenticacaoService.getValorUsuarioAtualCandidato) {
      this.router.navigate(['/vagas/lista']);
    }

  }

  ngOnInit() {

    this.fgCadastroUsuario = this.fb.group({
      // Dados pessoais
      cpf: ['', [
        CpfValidator.cpfInvalido,
        Validators.required
      ]], // Campo: CPF
      nome: ['', [Validators.required]], // Campo: Nome
      idGenero: ['', [Validators.required]], // Campo: Sexo
      dataNascimento: ['', [Validators.required]], // Campo: Data de Nascimento
      rg: ['', [Validators.required]], // Campo: RG
      orgaoEmissorRG: ['', [Validators.required]], // Campo: Órgão Emissor
      ufEmissorRG: ['', [Validators.required]], // Campo: UF do RG
      idEstadoCivil: ['', [Validators.required]], // Campo: Estado Civil
      nomeMae: ['', [Validators.required]], // Campo: Nome da Mãe
      // Endereço
      cep: ['', [Validators.required]], // Campo: CEP
      uf: ['', [Validators.required]], // Campo: UF
      cidade: ['', [Validators.required]], // Campo: Cidade
      bairro: ['', [Validators.required]], // Campo: Bairro
      logradouro: ['', [Validators.required]], // Campo: Logradouro
      numero: ['', [Validators.required]], // Campo: Número
      complemento: '', // Campo: Complemento
      // Contato
      telefone: ['', [Validators.required]], // Campo: Telefone
      email: ['', [Validators.required, Validators.email]], // Campo: E-mail
      confirmarEmail: ['', [Validators.required, Validators.email]], // Campo: Confirmar E-mail
      // Segurança
      senha: ['', [Validators.required]], // Campo: Senha
      confirmarSenha: ['', [Validators.required]] // Campo: Confirmar Senha
    }, {
      validator: [
        CamposValidator.iguais('email', 'confirmarEmail'),
        CamposValidator.iguais('senha', 'confirmarSenha')
      ]
    });

  }

  ngAfterViewInit() {

    AppUtil.focalizarCampo('idCpf');

  }

  get c() {

    return this.fgCadastroUsuario.controls;

  }

  cadastrarSe() {

    this.enviando = true;

    if (this.fgCadastroUsuario.invalid) {
      return;
    }

    const oCadastroUsuario: CadastrarCandidato = Object.assign({}, this.fgCadastroUsuario.value);
    oCadastroUsuario.cpf = AppUtil.removerSinais(oCadastroUsuario.cpf);
    oCadastroUsuario.cep = AppUtil.removerSinais(oCadastroUsuario.cep);
    oCadastroUsuario.telefone = AppUtil.removerSinais(oCadastroUsuario.telefone);

    this.fgCadastroUsuario.disable();

    this.sisrhService
      .cadastrar(oCadastroUsuario)
      .subscribe(x => {
        if (x.success) {
          this.modalService.alert(
            's',
            'Sucesso',
            x.message
          ).subscribe(() => this.router.navigate(['/login']));
        } else {
          x.data.forEach(y => {
            this.modalService.alert(
              'a',
              'Atenção',
              y.message
            ).subscribe(() => this.ok());
          });
        }
      },
        () => {
          this.modalService.alert(
            'e',
            'Erro',
            'Ocorreu um erro. Tente novamente mais tarde.'
          ).subscribe(() => this.ok());
        });


  }

  ok() {

    this.fgCadastroUsuario.enable();
    this.enviando = false;
    AppUtil.focalizarCampo('idCpf');

  }

  verificarCpf() {

    const oCadastroUsuario: CadastrarCandidato = Object.assign({}, this.fgCadastroUsuario.value);
    oCadastroUsuario.cpf = AppUtil.removerSinais(oCadastroUsuario.cpf);

    this.sisrhService
      .existir(oCadastroUsuario.cpf)
      .subscribe(x => {
        if (x) {
          this.modalService.alert(
            'a',
            'Atenção',
            'O usuário já cadastrado. Por favor, clique o botão Ok para ser redirecionado para a tela da Recuperação da senha.'
          ).subscribe(() => this.router.navigate(['/recuperacao-senha']));
        }
      });

  }

}
